<template>
  <v-card raised="10" class="pa-md-4 mx-lg-auto" max-width="300">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-file-input multiple label="File input"></v-file-input>

      <v-btn :disabled="!valid" color="success" class="mr-4" @click="validate">Validate</v-btn>

      <v-btn color="error" class="mr-4" @click="reset">Reset Form</v-btn>

    </v-form>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    select: null,
    checkbox: false,
  }),

  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>